module.exports = __webpack_public_path__ + "img/la_padroneta_celebracio_v1_groc_120_x_120_pixels_500_milisegons.4b7d7188.gif";